
import React from 'react';

export default function SolutionsSection() {
  const solutions = [
    {
      id: 1,
      icon: 'ri-cloud-line',
      title: '碳排放管理平台',
      description: '智能化碳排放数据收集、分析与报告系统，实现精准碳足迹追踪',
      features: ['数据自动采集', '智能分析报告', '合规性检查', '趋势预测'],
      metrics: { value: '95%', label: '数据准确率' },
      image: 'https://readdy.ai/api/search-image?query=Advanced%20carbon%20emission%20management%20platform%20with%20digital%20dashboards%20displaying%20real-time%20emission%20data%2C%20environmental%20analytics%20charts%2C%20IoT%20sensors%20monitoring%20industrial%20facilities%2C%20clean%20modern%20control%20room%20with%20multiple%20screens%20showing%20carbon%20footprint%20tracking&width=600&height=400&seq=solution-001&orientation=landscape'
    },
    {
      id: 2,
      icon: 'ri-leaf-line',
      title: '绿色供应链解决方案',
      description: '构建端到端绿色供应链体系，实现全链条可持续管理',
      features: ['供应商评估', '绿色采购', '物流优化', '风险管控'],
      metrics: { value: '30%', label: '成本降低' },
      image: 'https://readdy.ai/api/search-image?query=Green%20supply%20chain%20solution%20with%20sustainable%20logistics%20network%2C%20eco-friendly%20transportation%20vehicles%2C%20renewable%20energy%20powered%20warehouses%2C%20digital%20supply%20chain%20monitoring%20systems%2C%20environmental%20certification%20processes&width=600&height=400&seq=solution-002&orientation=landscape'
    },
    {
      id: 3,
      icon: 'ri-exchange-line',
      title: '碳交易与金融服务',
      description: '专业的碳资产管理和交易服务，最大化碳资产价值',
      features: ['资产评估', '交易撮合', '风险对冲', '投资咨询'],
      metrics: { value: '1000+', label: '交易项目' },
      image: 'https://readdy.ai/api/search-image?query=Carbon%20trading%20and%20financial%20services%20platform%20with%20professional%20trading%20floor%2C%20financial%20data%20displays%2C%20carbon%20credit%20trading%20interfaces%2C%20investment%20analysis%20charts%2C%20modern%20fintech%20environment%20with%20green%20finance%20elements&width=600&height=400&seq=solution-003&orientation=landscape'
    },
    {
      id: 4,
      icon: 'ri-lightbulb-line',
      title: '智慧能源管理系统',
      description: '基于AI和IoT的智能能源管理平台，实现能源使用最优化',
      features: ['实时监控', 'AI优化', '预测维护', '成本控制'],
      metrics: { value: '40%', label: '节能效果' },
      image: 'https://readdy.ai/api/search-image?query=Smart%20energy%20management%20system%20with%20IoT%20sensors%2C%20AI-powered%20control%20panels%2C%20real-time%20energy%20monitoring%20displays%2C%20automated%20optimization%20systems%2C%20modern%20industrial%20control%20room%20with%20energy%20efficiency%20dashboards&width=600&height=400&seq=solution-004&orientation=landscape'
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-600 rounded-full text-sm font-medium mb-4">
            解决方案
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            智能化碳管理解决方案
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            通过先进的技术手段和专业服务，为企业提供完整的碳管理和绿色转型解决方案
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {solutions.map((solution, index) => (
            <div key={solution.id} className={`bg-gradient-to-br ${index % 2 === 0 ? 'from-emerald-50 to-blue-50' : 'from-blue-50 to-indigo-50'} rounded-2xl p-8 hover:shadow-xl transition-all duration-300 group`}>
              <div className="flex flex-col lg:flex-row gap-6">
                {/* Content */}
                <div className="flex-1">
                  <div className="flex items-center mb-4">
                    <div className={`w-12 h-12 ${index % 2 === 0 ? 'bg-emerald-100' : 'bg-blue-100'} rounded-lg flex items-center justify-center mr-4`}>
                      <i className={`${solution.icon} ${index % 2 === 0 ? 'text-emerald-600' : 'text-blue-600'} text-xl`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{solution.title}</h3>
                  </div>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {solution.description}
                  </p>
                  
                  {/* Features */}
                  <div className="grid grid-cols-2 gap-3 mb-6">
                    {solution.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center text-sm text-gray-600">
                        <i className={`ri-check-line ${index % 2 === 0 ? 'text-emerald-500' : 'text-blue-500'} mr-2`}></i>
                        {feature}
                      </div>
                    ))}
                  </div>
                  
                  {/* Metrics */}
                  <div className="flex items-center justify-between mb-6">
                    <div className={`px-4 py-2 ${index % 2 === 0 ? 'bg-emerald-100 text-emerald-700' : 'bg-blue-100 text-blue-700'} rounded-lg`}>
                      <div className="text-2xl font-bold">{solution.metrics.value}</div>
                      <div className="text-sm">{solution.metrics.label}</div>
                    </div>
                    <button 
                      onClick={scrollToContact}
                      className={`px-6 py-3 ${index % 2 === 0 ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-blue-600 hover:bg-blue-700'} text-white rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap`}
                    >
                      了解详情
                      <i className="ri-arrow-right-line ml-2"></i>
                    </button>
                  </div>
                </div>
                
                {/* Image */}
                <div className="lg:w-80">
                  <div className="h-48 lg:h-64 rounded-xl overflow-hidden">
                    <img 
                      src={solution.image}
                      alt={solution.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
